import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function DashboardRedirect() {
    const { user, loading } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (loading) return;
        if (!user) navigate("/login", { replace: true });
        else {
            const dest = user.role === "employer" ? "/employer/dashboard"
                : user.role === "hiring_team" ? "/team/dashboard"
                : user.role === "recruiter" ? "/recruiter/dashboard"
                : "/professional/dashboard";
            navigate(dest, { replace: true });
        }
    }, [user, loading, navigate]);

    return (
        <div className="min-h-[70vh] flex items-center justify-center bg-background">
            <Loader2 size={24} className="animate-spin text-emerald-500" />
        </div>
    );
}
